import sanitize from './sanitize'

function Cell(props) {
  return (
    <td
      style={props.allNumbers ? { width: '70px', minWidth: '70px', maxWidth: '70px' } : undefined}
      className={`text-xs ${props.cell.class || ''} ${props.allNumbers ? 'font-monospace text-center align-middle' : 'text-truncate'}`}
      data-tooltip-id="app-tooltip"
      data-tooltip-content={props.cell.message}
      // Bug de seguridad real (auditoría 2026-08-16): XSS persistente — este
      // dangerouslySetInnerHTML renderizaba props.cell.value crudo, sin
      // sanitize(). El fix de XSS anterior (commit a98e9c8) sólo tocó la
      // vista horizontal inline en Table.js; nunca llegó a Row.js/Cell.js,
      // que alimenta la vista VERTICAL (default) con el mismo texto libre
      // (notas de diagnóstico/tratamiento) — un <script>/onerror=/
      // javascript: cargado por cualquiera del equipo ejecutaba contra
      // quien abriera esa ficha en esta vista.
      dangerouslySetInnerHTML={{
        __html: sanitize(props.cell.value || ''),
      }}
    />
  )
}

export default Cell
